import { createContext } from 'react';
export const DownloadDataContext = createContext(null);
export const DownloadMethodsContext = createContext(null);
